import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .title': {
    marginBottom: theme.spacing(2),
  },
  '& .PMOpp': {
    '& .desc > p:not(:last-child)': {
      fontWeight: 500,
      fontSize: theme.typography.pxToRem(21),
      marginBottom: theme.spacing(1),
      [theme.breakpoints.down('lg')]: {
        fontSize: theme.typography.pxToRem(18),
        marginBottom: theme.spacing(0.5),
      },
    },
    '& ul': {
      marginBottom: theme.spacing(3),
    },
  },
}));

export default StyledBox;
